module.exports = __webpack_public_path__ + "static/media/200degs2.646971ab.jpg";